import { render, staticRenderFns } from "./TicketImage.vue?vue&type=template&id=6361ca1e&scoped=true"
import script from "./TicketImage.vue?vue&type=script&lang=js"
export * from "./TicketImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6361ca1e",
  null
  
)

export default component.exports